function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState, useContext, forwardRef } from 'react';
import { node, string, bool } from 'prop-types';
import cn from 'classnames';
import ModalContext from '../../context/ModalContext';
/**
 * Modal Body component.
 */

var Body = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      maxHeight = _ref.maxHeight,
      noScroll = _ref.noScroll;
  var transitionSpeed = 200;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      enableBodyTransition = _useState2[0],
      setEnableBodyTransition = _useState2[1];

  var _useContext = useContext(ModalContext),
      show = _useContext.show,
      fluid = _useContext.fluid; // Enable body transition only after the modal is first mounted
  // to prevent any weirdness when the modal first appears. The 0 timeout adds
  // the function to the message queue to execute immediately after first mount.


  useEffect(function () {
    var timer;

    if (show) {
      timer = setTimeout(function () {
        return setEnableBodyTransition(true);
      }, 0);
    } else {
      setEnableBodyTransition(false);
    }

    return function () {
      clearTimeout(timer);
      setEnableBodyTransition(false);
    };
  }, [show]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('modal__body', className),
    ref: ref,
    style: {
      maxHeight: fluid ? null : maxHeight,
      transition: enableBodyTransition ? "max-height ".concat(transitionSpeed, "ms") : null,
      overflowY: noScroll ? 'hidden' : 'auto'
    }
  }, children);
});
Body.displayName = 'Modal.Body';
Body.defaultProps = {
  children: null,
  className: null,
  maxHeight: '377px',
  noScroll: false
};
Body.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The content of the body */
  children: node,

  /** Additional class names to add to the component root. */
  className: string,

  /** Maximum height of the modal, which will transition when updated. */
  maxHeight: string,

  /** Prevent the modal body from scrolling. */
  noScroll: bool
} : {};
export default Body;